import { useSetRecoilState } from 'recoil';
import { CloseIcon } from '@/ui/icons';
import { closeModalSelector, pushModalSelector } from '@/stores/modalStore';
import { ModalWrapper } from '@/core/modal';
import { useLocalization } from '@/services/localizationService';
import { UserAction } from '@/services/userService';

import headerImage from '@/public/images/showcase/login-preferences.webp';
import OnboardingModal from '@/features/onboarding/OnboardingModal';
import { useTracker } from '@/core/tracking';

export default function LoginToSaveSettingsModal({
  id,
  ...rest
}: {
  id: string;
}) {
  const closeModal = useSetRecoilState(closeModalSelector);
  const pushModal = useSetRecoilState(pushModalSelector);

  const { t, data } = useLocalization();
  const { track } = useTracker();

  return (
    <ModalWrapper
      className="text-center flex flex-col justify-between p-10 pb-6 w-auto max-w-[350px] lg:w-2/5 relative overflow-hidden"
      {...rest}
    >
      <div className="absolute w-[100%] h-[100%] top-0 start-0 z-0" />
      <div className="flex justify-start items-center">
        <button
          type="button"
          onClick={() => {
            track('ai_settings', 'saving_modal_dismissed');
            closeModal(id);
          }}
        >
          <CloseIcon className="text-gray-300 drop-shadow" />
        </button>
      </div>
      <div className="flex justify-center -mt-5">
        <img {...headerImage} className="w-52" alt="header" />
      </div>
      <div className="text-start z-10">
        <p className="SB20 text-black text-center mt-2">
          {t(data.onboarding.loginToUseThisFeature)}
        </p>
        <p className="M16 text-black text-center mt-3 whitespace-pre-line">
          {t(data.onboarding.loginToUsePreferencesModalBody)}
        </p>
        <p className="text-white text-center mb-4 mt-2">
          <button
            type="button"
            className="w-full btn btn--large shadow-dark-button btn--black mt-6 focus:outline-none"
            onClick={() => {
              track('ai_settings', 'saving_modal_accepted');
              pushModal({
                id: 'user:onboarding',
                Modal: OnboardingModal,
                previousAction: UserAction.SaveSettings,
              });

              closeModal(id);
            }}
          >
            {t(data.onboarding.proceedToLogin)}
          </button>
        </p>
      </div>
    </ModalWrapper>
  );
}
